import { createPatchEndpoint } from '@sonar-software/sonar-http';
import { UserNotificationPreferences } from '@types';

export type PatchUserNotificationPreferencesRequest = Partial<UserNotificationPreferences> & {
	userId: number;
};

export const patchUserNotificationPreferences = createPatchEndpoint<PatchUserNotificationPreferencesRequest, void>(
	(request) => `/api/v2/user/${request.userId}/notification-preferences`,
	{
		requestTransform: ({ userId, ...rest }) => ({ ...rest })
	}
);
